import { Star, Quote, ExternalLink } from "lucide-react";
import { GBP_URL } from "../../lib/business";

const REVIEWS = [
  {
    name: "Sarah M.",
    suburb: "Merewether",
    quote:
      "Booked them for a full detail before I sold my car — looked better than the day I bought it. Genuinely impressed.",
  },
  {
    name: "Daniel R.",
    suburb: "Newcastle West",
    quote:
      "Showed up on time, set up at my apartment block, and absolutely transformed the interior. Will use every month.",
  },
  {
    name: "Priya K.",
    suburb: "Charlestown",
    quote:
      "Easy to talk to over the phone, no upsell, just quality work. The hand polish on the exterior is a different level.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative bg-[#0b0b0e] py-24 sm:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="font-display text-xs uppercase tracking-[0.3em] text-[#E10600] mb-3">
              / Reviews
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter text-white max-w-2xl">
              5.0 on Google.
              <br />
              <span className="text-white/70">
                Earned, one car at a time.
              </span>
            </h2>
          </div>
          <a
            href={GBP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-reviews-link"
            className="inline-flex items-center gap-2 border border-white/15 hover:border-white/40 bg-white/5 hover:bg-white/10 backdrop-blur text-white font-display uppercase tracking-wide font-bold text-sm px-5 py-3 rounded-full transition-colors"
          >
            See on Google
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative p-8 rounded-2xl bg-zinc-900/70 border border-white/10 overflow-hidden"
            >
              <Quote className="absolute -top-2 -right-2 w-24 h-24 text-white/[0.03]" />
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Star
                    key={j}
                    className="w-4 h-4 fill-[#E10600] text-[#E10600]"
                  />
                ))}
              </div>
              <p className="font-body text-base text-zinc-200 leading-relaxed">
                &ldquo;{r.quote}&rdquo;
              </p>
              <div className="mt-6 pt-5 border-t border-white/10">
                <div className="font-display text-base uppercase font-bold text-white tracking-tight">
                  {r.name}
                </div>
                <div className="font-body text-xs uppercase tracking-widest text-zinc-500 mt-1">
                  {r.suburb} · Newcastle
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
